module.exports = __webpack_public_path__ + "static/media/AsheBrewingpostcarddetail.e354b05f.webp";